import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import {of as observableOf,  Observable } from 'rxjs';
import {catchError} from 'rxjs/operators';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/response';
import { AttendeeActivityFilter, DropDownFilter, IAttendeeActivityLogs, IDropDownItems } from './activitylogs-model';

@Injectable()
export class ActivityLogsService {
    constructor(
        private http: HttpClient
    ) { }

    private static get URL(): string { return `${environment.dashboardApi.baseUrl}${environment.dashboardApi.prefix}`; }
    private static readonly ENDPOINT = 'activities';

    public getDropDown(filter: DropDownFilter): Observable<SuccessResponse<IDropDownItems> | ErrorResponse>  {
        return this.http.post<SuccessResponse<IDropDownItems>>(
            ActivityLogsService.URL +
            ActivityLogsService.ENDPOINT + '/dropdowns', filter)
        .pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    public getAttendeeLogs(activityFilter: AttendeeActivityFilter): Observable<SuccessResponse<IAttendeeActivityLogs> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<IAttendeeActivityLogs>>(
                ActivityLogsService.URL +
                ActivityLogsService.ENDPOINT +  '/attendees',
                activityFilter)
            .pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

}
